import React, { Component } from "react";
import { FormGroup, FormControl, Col, Radio, Grid } from "react-bootstrap";
export default class Between extends Component {
  render() {
    return (
      <div>
        {this.props.show ? (
          <Grid>
            <Col md={12}>
              <Col md={2}>
                <Radio
                  defaultChecked={
                    this.props.wheretosearch !== "everywhere" ? true : false
                  }
                  disabled={
                    this.props.wheretosearch !== "everywhere" ? false : true
                  }
                  name={"andor-" + this.props.id}
                  value="and"
                  inline
                >
                  and
                </Radio>{" "}
                <Radio
                  defaultChecked={
                    this.props.wheretosearch === "everywhere" ? true : false
                  }
                  name={"andor-" + this.props.id}
                  value="or"
                  inline
                >
                  or
                </Radio>{" "}
                <Radio
                  disabled={
                    this.props.wheretosearch !== "everywhere" ? false : true
                  }
                  name={"andor-" + this.props.id}
                  value="andnot"
                  inline
                >
                  and-not
                </Radio>{" "}
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Col md={2}>Within</Col>
                  <Col md={6}>
                    <FormControl
                      disabled={
                        this.props.wheretosearch !== "everywhere" ? false : true
                      }
                      type="text"
                      name={"numbering-" + this.props.id}
                      placeholder=""
                    />{" "}
                    {/* aktiveres kun når man velger "within one line"; numbering hvis 2 betyr mellom -20 og +20 */}
                  </Col>
                  <Col md={2}>words</Col>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Col md={4}>
                    {/* phys_word.size .. skal hentes fra db */}
                    <FormControl
                      name={"avstand-" + this.props.id}
                      componentClass="select"
                      placeholder="select"
                    >
                      <option value="near">near</option>
                      <option value="before">before</option>
                      <option value="after">after</option>
                    </FormControl>
                  </Col>
                  <Col md={2}>first word</Col>
                </FormGroup>
              </Col>
            </Col>
          </Grid>
        ) : (
          ""
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/Forms/Between.jsx